import nodeApi from '../utils/nodeApiClient';

const recurringInvoiceApi = {
  list: (params) => nodeApi.get('/recurring-invoices', { params }),
  getDetails: (invoiceId) => nodeApi.get('/recurring-invoices/details', { params: { invoice_id: invoiceId } }),
  createNext: (data) => nodeApi.post('/recurring-invoices/details', data)
};

export default recurringInvoiceApi;
